export interface IBrowserInformation {
  title: Browser;
  version: IBrowserVersion;
  download: string;
}

export interface IBrowserVersion {
  major: number;
  minor: number;
}

export const Browser = {
  CHROME: { userAgentLookup: 'Chrome/', label: 'Chrome' },
  EDGE: { userAgentLookup: 'Edg/', label: 'Edge' },
  SAFARI: { userAgentLookup: 'Safari/', label: 'Safari' },
  FIREFOX: { userAgentLookup: 'Firefox/', label: 'Firefox' },
  UNKNOWN: { userAgentLookup: 'unknown/', label: 'Unknown' },
} as const
export type Browser = (typeof Browser)[keyof typeof Browser];
